const Prose = ({
  html,
  customClass = ""
}) => {
  return <div className={`prose prose-sm text-productDetails-description ${customClass}`} dangerouslySetInnerHTML={{
    __html: html
  }} data-sentry-component="Prose" data-sentry-source-file="Prose.jsx" />;
};
export default Prose;